import { FC } from 'react';
import { useFragment, graphql } from 'react-relay';

// components
import { PdpRespSharedItemDetailsList } from './PdpRespSharedItemDetailsList';
import { PdpRespSharedItemDetailsDescription } from './PdpRespSharedItemDetailsDescription';
import { PdpRespSharedItemDetailsAdditionalOptions } from './PdpRespSharedItemDetailsAdditionalOptions';

// styles
import styles from './PdpRespSharedItemDetails.scss';

// types
import { PdpRespSharedItemDetails_item$key as Item } from './__generated__/PdpRespSharedItemDetails_item.graphql';
import { PdpRespSharedItemDetails_user$key as User } from './__generated__/PdpRespSharedItemDetails_user.graphql';

const itemFragment = graphql`
    fragment PdpRespSharedItemDetails_item on Item {
        ...PdpRespSharedItemDetailsList_item
        ...PdpRespSharedItemDetailsDescription_item
        ...PdpRespSharedItemDetailsAdditionalOptions_item
    }
`;

const userFragment = graphql`
    fragment PdpRespSharedItemDetails_user on User {
        ...PdpRespSharedItemDetailsList_user
        ...PdpRespSharedItemDetailsAdditionalOptions_user
    }
`;

export const PdpRespSharedItemDetails: FC<{
    item: Item;
    dataTn?: string;
    currency: string;
    user: User | null;
    selectedSkuId: string | null;
    showExpandingArea?: boolean;
}> = ({ item: itemRef, user: userRef, dataTn, currency, selectedSkuId, showExpandingArea }) => {
    const item = useFragment(itemFragment, itemRef);
    const user = useFragment(userFragment, userRef);

    return (
        <div className={styles.aboutModule} data-tn={dataTn}>
            <div className={styles.aboutModuleInner}>
                <div className={styles.aboutColumn}>
                    <PdpRespSharedItemDetailsDescription
                        item={item}
                        showExpandingArea={showExpandingArea}
                    />
                    {/* Additional Options */}
                    <PdpRespSharedItemDetailsAdditionalOptions user={user} item={item} />
                </div>
                {/* Details */}
                <div className={styles.aboutColumn}>
                    <PdpRespSharedItemDetailsList
                        item={item}
                        user={user}
                        currency={currency}
                        selectedSkuId={selectedSkuId}
                    />
                </div>
            </div>
        </div>
    );
};
